import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'

import { GenericStatusComponent } from '@paysense-india-services/elevate-web'

import { ROUTES } from '@/constants/routes'

import { useProductConfig } from '@/contexts/ProductConfigContext'

import { applyRedirect } from '@/utils/navigation'

import AuthFormShell from '@/components/layouts/AuthFormShell'

import { GREEN_TICK } from '@/assets/images'

const ErrorIcon = () => (
  <div className="ew-d-flex ew-align-items-center ew-justify-content-center">
    <svg
      fill="none"
      height="120"
      viewBox="0 0 120 120"
      width="120"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Shadow */}
      <rect fill="rgba(0, 0, 0, 0.08)" height="104" rx="20" width="104" x="8" y="8" />
      {/* Icon Background */}
      <rect fill="#FEF2F2" height="120" rx="20" width="120" x="0" y="0" />
      {/* Error X */}
      <path
        d="M60 30C45.6406 30 34 41.6406 34 56C34 70.3594 45.6406 82 60 82C74.3594 82 86 70.3594 86 56C86 41.6406 74.3594 30 60 30ZM67.5 63.75L63.75 67.5L60 63.75L56.25 67.5L52.5 63.75L56.25 60L52.5 56.25L56.25 52.5L60 56.25L63.75 52.5L67.5 56.25L63.75 60L67.5 63.75Z"
        fill="#EF4444"
      />
    </svg>
  </div>
)

const VerificationStatusPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { appendProductParams, getEmailVerifiedReturnUrl } = useProductConfig()
  const status = searchParams.get('status') || 'success'
  const email = searchParams.get('email') || ''

  useEffect(() => {
    // Redirect to email verification if no status provided
    if (!searchParams.get('status')) {
      navigate(`${ROUTES.EMAIL_VERIFICATION}?${appendProductParams().toString()}`)
    }
  }, [searchParams, navigate, appendProductParams])

  const isSuccess = status === 'success'

  const getSubtitle = () => {
    if (isSuccess) {
      return email
        ? `Your email ${email} has been successfully verified.`
        : 'Your email has been successfully verified.'
    }
    return email
      ? `Verification failed for ${email}. Please try again.`
      : 'Email verification failed. Please try again.'
  }

  return (
    <AuthFormShell headerVariant="logo">
      <GenericStatusComponent
        className="ew-mx-auto ew-shadow-none"
        LottieComp={isSuccess ? null : ErrorIcon}
        onPrimaryAction={() => {
          applyRedirect(getEmailVerifiedReturnUrl(), navigate)
        }}
        primaryBtnText="Okay, Done"
        statusIcon={isSuccess ? GREEN_TICK : ''}
        subtitle={getSubtitle()}
        title={isSuccess ? 'Email Verified' : 'Verification Failed'}
      />
    </AuthFormShell>
  )
}

export default VerificationStatusPage
